// @ts-nocheck
import {
    NotificationsFollowedModel,
    UserNotificationInviteCollegueModel,
    UserNotificationPreferencesModel,
} from "@insite/client-framework/Types/ApiModels";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface UserNotificationPreferencesContextModel extends UserNotificationPreferencesModel {
    isLoading: boolean;
    updateSuccessful?: boolean;
    updateErrorMessage?: string | null;
    setNotificationsFollowed: Dispatch<SetStateAction<NotificationsFollowedModel | null>>;
    setCustomerSoldTo: Dispatch<SetStateAction<UserNotificationInviteCollegueModel | null>>;
    setIsLoading: Dispatch<SetStateAction<boolean>>;
    setResponseCode: Dispatch<SetStateAction<string>>;
    setErrorMessage: Dispatch<SetStateAction<string | null>>;
    setUpdateSuccessful?: Dispatch<SetStateAction<boolean>>;
    setUpdateErrorMessage?: Dispatch<SetStateAction<string | null | undefined>>;
}

export const defaultContext: UserNotificationPreferencesContextModel = {
    isLoading: true,
    notificationsFollowed: {},
    customerSoldTo: {},
    responseCode: "success",
    errorMessage: null,
    setIsLoading: parameter => parameter,
    setNotificationsFollowed: () => {},
    setCustomerSoldTo: () => {},
    setResponseCode: () => {},
    setErrorMessage: () => {},
};

export const UserNotificationPreferencesContext =
    createContext<UserNotificationPreferencesContextModel>(defaultContext);

export const useUserNotificationPreferencesContext = () => {
    const context = useContext(UserNotificationPreferencesContext);

    if (!context) {
        throw new Error("User Notification Preferences Context is called outside a provider.");
    }

    return context;
};
